import { BookingStatus, BookingStatusEnum } from '@/types';

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  [BookingStatus.PENDING]: 'Pending',
  [BookingStatus.COMPLETED]: 'Completed',
  [BookingStatus.DECLINED]: 'Canceled',
  [BookingStatusEnum.FUTURE]: 'Future',
};

export const getBookingStatusLabel = (status: string): string => {
  return (
    BOOKING_STATUS_LABELS[status] ||
    status.charAt(0).toUpperCase() + status.slice(1)
  );
};
